import React from 'react';
import styles from './ReportCardHeader.module.scss';
import { ReportCardHeaderActions } from './ReportCardHeaderActions/ReportCardHeaderActions';
import { SFText } from 'sfui';
import { ReportableChip } from '../../ReportChips/ReportableChip/ReportableChip';
import { StatusChip } from '../../ReportChips/StatusChip/StatusChip';
import { ReportStatusValue } from '../../../Models';

export interface ReportCardHeaderProps {
  className?: string;
  incidentNumber: string;
  caseNumber?: string | undefined;
  isReportable?: boolean;
  status?: ReportStatusValue;
  onViewHistory: () => void;
  onScanQrCode: () => void;
  onSeeFullReport: () => void;
}

export const ReportCardHeader = ({
  className = '',
  incidentNumber,
  caseNumber,
  isReportable,
  status,
  onViewHistory,
  onScanQrCode,
  onSeeFullReport
}: ReportCardHeaderProps): React.ReactElement<ReportCardHeaderProps> => {
  return (
    <div className={`${styles.reportCardHeader} ${className}`}>
      <div className={styles.information}>
        <div className={styles.incidentNumber}>
          <SFText type="component-messages" sfColor="neutral">
            {caseNumber ? 'CAD / CASE NUMBER' : 'INCIDENT NUMBER'}
          </SFText>
          <SFText type="component-title">{caseNumber || incidentNumber}</SFText>
        </div>

        <ReportCardHeaderActions
          onViewHistory={onViewHistory}
          onScanQrCode={onScanQrCode}
          onSeeFullReport={onSeeFullReport}
        />
      </div>
      <div className={styles.valueAndChips}>
        <SFText type="component-messages" sfColor="neutral">
          CONTACT
        </SFText>
        <div className={styles.chips}>
          <ReportableChip isReportable={isReportable} />
          <StatusChip
            isReportable={isReportable}
            status={status}
            size="small"
          />
        </div>
      </div>
    </div>
  );
};
